/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jsmEmailDomainsListResource } from '@jira/router-resources__get-email-domains-list/src/jsmEmailDomainsListResource.tsx';
import { productsJsmOrganizationDetailsResource } from '@jira/router-resources__organization-details/src/productsJsmOrganizationDetailsResource.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceDeskOrganizationPanelForgeDataResource } from '@jira/router-resources__service-desk-org-panel-forge-data/src/serviceDeskOrganizationPanelForgeDataResource.tsx';
import { servicedeskOrganizationV2Route } from '@jira/router-routes__servicedesk-organization-routes/src/servicedeskOrganizationV2Route.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { ServiceDeskOrganizationV2, LazyServicedeskOrganizationV2 } from './ui/index.tsx';

export const servicedeskOrganizationV2RouteEntry: Route = createEntry(
	servicedeskOrganizationV2Route,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			serviceDeskOrganizationPanelForgeDataResource,
			getConsolidationStateResource(),
			productsJsmOrganizationDetailsResource,
			jsmEmailDomainsListResource,
		],

		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskOrganizationV2,
		forPaint: [LazyAtlassianNavigation, LazyServicedeskOrganizationV2],
		perfMetricKey: 'jsm-organizations-component-load',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
